export const photoCaptureUpdateFraudWarningAcceptReducer = (state, action) => {
    return Object.assign(Object.assign({}, state), { fraudWarningAccept: action.payload, isFraudWarningApiStatus: false });
};
//# sourceMappingURL=photoCaptureUpdateFraudWarningAcceptReducer.js.map